import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useRedline } from '@libs/redline';
import { handleFullFunnelRedirect } from '@libs/creditkit';

import { RouteMap } from '@common/constants/RouteMap';
import constantsRedline from '@common/constants/redline';
import { safeLocalStorage } from '@consumidor-positivo/ts-utils';

import { useAuthentication } from '@libs/acp/contexts/Authentication'; 

const PublicRoute = () => {
	const { isAuthenticated, preventRedirect } = useAuthentication();
  const { pathname, state } = useLocation();
  const { createCorrelationId } = useRedline();

  useEffect(() => {
    createCorrelationId(constantsRedline.RL_TRACK_CID);
  }, []);

  const isHelpCenter = pathname === RouteMap.Help;
  const redirectPath = safeLocalStorage.getItem('redirectAfterLogin');
  const { isFullFunnelOrigin, partnerSlug } = handleFullFunnelRedirect();

  if (isAuthenticated && !isHelpCenter && !preventRedirect) {
		if (redirectPath) {
      safeLocalStorage.removeItem('redirectAfterLogin');
      return <Navigate to={redirectPath} replace />;
    }

    if (isFullFunnelOrigin) {
      return <Navigate to={RouteMap.FullFunnelRedirect} replace state={{ partnerSlug }} />;
    }

    if (state && state.from !== RouteMap.Logout) return <Navigate to={RouteMap.Dashboard} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
